import React from "react";
import PropTypes from "prop-types";
import {
  Section,
  FormCard,
  Title,
  Label,
  Input,
  Button,
  Message,
  Honeypot,
} from "./style";

const encode = (data) =>
  Object.keys(data)
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`)
    .join("&");

class SubscribeForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      formValues: {
        email: "",
        "bot-field": "",
      },
      status: "idle",
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    const { name, value } = event.target;
    this.setState((prevState) => ({
      formValues: {
        ...prevState.formValues,
        [name]: value,
      },
    }));
  }

  handleSubmit(event) {
    event.preventDefault();

    const { status, formValues } = this.state;
    const { formName } = this.props;

    if (!formValues.email || status === "submitting") {
      return;
    }

    this.setState({ status: "submitting" });

    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({
        "form-name": formName,
        ...formValues,
      }),
    })
      .then(() => {
        this.setState({
          status: "success",
          formValues: {
            email: "",
            "bot-field": "",
          },
        });
      })
      .catch(() => {
        this.setState({ status: "error" });
      });
  }

  render() {
    const { formValues, status } = this.state;
    const { formName } = this.props;

    return (
      <Section>
        <FormCard
          name={formName}
          method="POST"
          data-netlify="true"
          data-netlify-honeypot="bot-field"
          onSubmit={this.handleSubmit}
        >
          <input type="hidden" name="form-name" value={formName} />
          <Honeypot aria-hidden="true">
            <label>
              Don’t fill this out if you’re human:
              <input
                name="bot-field"
                onChange={this.handleChange}
                value={formValues["bot-field"]}
                tabIndex="-1"
              />
            </label>
          </Honeypot>

          <Title>Subscribe for updates</Title>
          {/* <Label htmlFor="subscribe-email">Email address</Label>*/}
          <Input
            id="subscribe-email"
            name="email"
            type="email"
            placeholder="email address"
            autoComplete="email"
            value={formValues.email}
            onChange={this.handleChange}
            required
          />
          <Button type="submit" disabled={status === "submitting"}>
            {status === "submitting" ? "Sending…" : "Subscribe"}
          </Button>
          {status === "success" && (
            <Message role="status">✅ Submitted</Message>
          )}
          {status === "error" && (
            <Message role="alert">
              Something went wrong. Please try again.
            </Message>
          )}
        </FormCard>
      </Section>
    );
  }
}

SubscribeForm.propTypes = {
  formName: PropTypes.string,
};

SubscribeForm.defaultProps = {
  formName: "subscribe",
};

export default SubscribeForm;



// WEBPACK FOOTER //
// ./src/components/SubscribeForm/index.js